import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RfpLabelService {
  public isRFPorRFQ: string;
  
  updateRFPorRFQFlag(currentRoute: string) {
    const _currentRoute = currentRoute.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(_currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
    return this.isRFPorRFQ;
  }

  private LABELS = {
    RFP: {
      title: 'Request for Proposal (RFP)',
      titleFieldLabel: 'Enter RFP Title',
      titleFieldRequiredError: 'RFP Title is required',
      issueOfRFPLabel: 'Issue Date',
      rfpMode: 'RFP',
    },
    RFQ: {
      title: 'Request for Quote (RFQ)',
      titleFieldLabel: 'Enter RFQ Title',
      titleFieldRequiredError: 'RFQ Title is required',
      issueOfRFPLabel: 'Issue Date',
      rfpMode: 'RFQ',
    },
  };

  private labelsSubject = new BehaviorSubject<any>({});
  labels$ = this.labelsSubject.asObservable();

  constructor() {
    // No route checking here
  }

  /**
   * Updates the labels based on the provided route.
   * This method should be called from the component with the correct route string.
   */
  updateLabelsFromRoute(currentRoute: string) {
    currentRoute = currentRoute.toLowerCase();

    const isRFP = currentRoute.includes('rfp');
    const isRFQ = currentRoute.includes('rfq');

    if (isRFP) {
      this.labelsSubject.next(this.getLabels('RFP'));
    } else if (isRFQ) {
      this.labelsSubject.next(this.getLabels('RFQ'));
    }
  }

  getLabels(mode: 'RFP' | 'RFQ') {
    return this.LABELS[mode] || { title: '' };
  }
}
